
<div class="logo" *ngIf="showNav">
  <img src="assets/img/logo.png">
</div>
<div class="menus" *ngIf="showNav">
  <div [routerLink]="'/admin/dashboard'" [routerLinkActive]="['active']">Dashboard</div>
  <div [routerLink]="'/admin/data-visuals'" [routerLinkActive]="['active']">Data-visualization</div>
  <div [routerLink]="['/admin/applications']" [routerLinkActive]="['active']" *ngIf="userPermissions && (userPermissions.includes('view_apptemplate') || userPermissions.includes('view_app'))">Applications</div>
  <div [routerLink]="['/sensors']" [routerLinkActive]="['active']" *ngIf="userPermissions && userPermissions.includes('view_sensor')">Sensors</div>
  <div [routerLink]="'/admin/organizations'"  [routerLinkActive]="['active']" *ngIf="userPermissions && userPermissions.includes('view_organization')">Organizations</div>
  <div [routerLink]="'/admin/labs'"  [routerLinkActive]="['active']" *ngIf="userPermissions && userPermissions.includes('view_lab')">Labs</div>
  <div [routerLink]="'/admin/devices'" [routerLinkActive]="['active']" *ngIf="userPermissions && userPermissions.includes('view_device')">Devices</div>
  <div [routerLink]="'/admin/lab-users'"  [routerLinkActive]="['active']" *ngIf="userPermissions && userPermissions.includes('view_lab_user')">Lab Users</div>
  <div [routerLink]="'/admin/users'"  [routerLinkActive]="['active']" *ngIf="userPermissions && userPermissions.includes('view_user')">IDE Admin Users</div>
  <div [routerLink]="'/admin/user-permissions'" [routerLinkActive]="['active']" *ngIf="userPermissions && userPermissions.includes('view_permission')">User Permissions</div>
  <div [routerLink]="['/admin/template/create']" [routerLinkActive]="['active']" *ngIf="userPermissions && userPermissions.includes('view_apptemplate')">Create Application</div>
  <!-- <div [routerLink]="['/admin/users-session']" [routerLinkActive]="['active']">User Sessions</div> -->
  <div [routerLink]="'/admin/circuit'" [routerLinkActive]="['active']" *ngIf="userPermissions && (userPermissions.includes('view_apptemplate') && userPermissions.includes('view_app') && userPermissions.includes('view_sensor'))">Circuit Design</div>
  <div [routerLink]="'/admin/block'" [routerLinkActive]="['active']" *ngIf="userPermissions && (userPermissions.includes('view_apptemplate') && userPermissions.includes('view_app'))">Block Design</div>
  <!-- <div  [routerLink]="['/admin/python-direct']" [routerLinkActive]="['active']">Python Direct</div> -->
</div>
<!-- <div class="logout" *ngIf="showNav">
  <img  src="assets/img/sidenav/exit.svg" class="h-10" (click)="logout()">
</div> -->
<div class="logout" [class.show]="isProfileView">
  <img  src="assets/img/sidenav/profileforusername.png" class="h-10 cursor-pointer" (click)="viewProfile('view')"(document:click)="closeProfile($event)">
  <div class="dropdown-menu mt-2 p-2 px-2" [class.show]="isProfileView">
    <div class="close">
      <img  src="assets/img/sidenav/cross.png" class="h-10" (click)="viewProfile()">
    </div>
    <div class="d-flex align-items-center justify-content-center cursor-pointer profile-box">
      <div class="custom-tooltip">{{ userName }}</div>
      <img src="assets/img/sidenav/username1.png" class="h-10" >
      <span class="dropdown-item username">{{userName}}</span>
    </div>
    <div class="d-flex align-items-center profile-box1" (click)="logout()">
      <img src="assets/img/sidenav/Signup.png" class="h-14" >
      <span class="logout-text">Logout</span>
    </div>
  </div>
</div>


<!-- <div class="logout flex flex-row items-center">
  <span class="v1"></span>
  <span class="p-2 justify-center"> 
    <img style="width:48px;height:25px;" src="assets/img/sidenav/Logout.svg" (click)="logout()">
  </span> 
  <span class="text-red-600 p-2 justify-center font-normal text-lg" (click)="logout()">
    Logout
  </span>
</div> -->

